/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiOAuthUrlPropertiesFromJSON, StreemApiOAuthUrlPropertiesToJSON, } from './';
export function StreemApiCreatePiiRequestRequestFromJSON(json) {
    return StreemApiCreatePiiRequestRequestFromJSONTyped(json, false);
}
export function StreemApiCreatePiiRequestRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'externalUserId': !exists(json, 'external_user_id') ? undefined : json['external_user_id'],
        'includeSubCompanies': !exists(json, 'include_sub_companies') ? undefined : json['include_sub_companies'],
        'customIdentifier': !exists(json, 'custom_identifier') ? undefined : json['custom_identifier'],
        'webhookUrl': !exists(json, 'webhook_url') ? undefined : json['webhook_url'],
        'oauthUrl': !exists(json, 'oauth_url') ? undefined : json['oauth_url'],
        'oauthUrlProperties': !exists(json, 'oauth_url_properties') ? undefined : StreemApiOAuthUrlPropertiesFromJSON(json['oauth_url_properties']),
    };
}
export function StreemApiCreatePiiRequestRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'external_user_id': value.externalUserId,
        'include_sub_companies': value.includeSubCompanies,
        'custom_identifier': value.customIdentifier,
        'webhook_url': value.webhookUrl,
        'oauth_url': value.oauthUrl,
        'oauth_url_properties': StreemApiOAuthUrlPropertiesToJSON(value.oauthUrlProperties),
    };
}
//# sourceMappingURL=StreemApiCreatePiiRequestRequest.js.map